import styled from 'styled-components'
import { Spacer } from '../_theme/spacer'
import { Colors } from '../_theme/color'
import { MediaQuery } from '../_theme/media-query'
import Card, { shadowSmall } from '../_children/Card/Card'

const ImgCover = styled.img`
  max-width: 200px;
  width: 100%;

  ${MediaQuery.mobile} {
    max-width: 150px;
  }
`

const WrapCover = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-direction: column;
  margin: ${Spacer.space3} ${Spacer.space2};
  height: 360px;
`

const BackgroundArrow = styled.div`
  display: flex !important;
  background-color: ${Colors.Yellow};
  padding: 15px 6px;
  border-radius: 10%;
  align-items: center;
  text-align: center;
  top: 70%;

  ::before {
    display: none;
  }

  svg {
    width: 16px !important;
    height: 32px;
  }

  :hover {
    background-color: ${Colors.YellowHover};
  }
`

const WrapSlider = styled.div`
  width: calc(100% - 120px);
  margin: auto;

  ${MediaQuery.lessThanOrEqualToTablet} {
    width: calc(100vw - 80px);
  }
`
const WrapCard = styled(Card)`
  ${shadowSmall};
  cursor: pointer;
`

const CardTopHead = styled.div`
  background-color: #ff7f50;
  border-radius: 10px 10px 0px 0px;
  color: white;
  font-size: 12px;
  padding: 3px 15px;
  font-weight: 700;
`

const DefaultCover =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADUCAYAAADZTGx+AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABx0RVh0U29mdHdhcmUAQWRvYmUgRmlyZXdvcmtzIENTNui8sowAAAAWdEVYdENyZWF0aW9uIFRpbWUAMTAvMjAvMjXq6yKTAAACt0lEQVR4nO3dwWnjUBRA0fGQBtSCW1D/JagFt6ASfnYhkJkbicSRY52ztD/4Ybj8hUDvMsYYf4B/+nv0APDIBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBBe9hxeluVeczyMeZ4/fLau6wGTnMM0Tf/97p7/e/3ue24QCAKBIBAIAoEgEAgCgSAQCAKBIBAIAoEgEAgCgSAQCAKBIBAIAoEgEAgCgSAQCAKBIBAIAoEgEAi73ot1VlvfocTzcYNAEAgEgUAQCASBQBAIBIFA8Bxkg9vtdvQIT+t6vR49QnKDQBAIBIFAEAgEgUAQCASBQBAIBIFAEAgEgUAQCASBQBAIBIFAEAgEgUAQCASBQBAIBIFAEAgEgUAQCASBQBAIhMsYYxw9BDwqNwgEgUAQCASBQBAIhF0LdNZ1vdcc/BLTNH16ZlmWH5jka+Z53nTODQJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEC5jjLH1sBVsbFnB9kzcIBAEAkEgEAQCYdeedNjCnnQ4CYFAEAgEgUAQCASBQBAIBIFAEAgEgUAQCASBQBAIBIFAEAgEgUAQCASBQBAIBIFAEAgEgUAQCASBQBAIBIFAEAgEgUAQCASBQBAIBIFAEAgEgUCwJ51d7EkH3ggEgkAgCASCPel8O3vS4SQEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCQSAQBAJBIBAEAkEgEAQCYdeedDgbNwgEgUAQCASBQBAIBIFAEAgEgUAQCASBQBAIBIFAEAgEgUAQCIRXhUkzz0pNYTAAAAAASUVORK5CYII='

export {
  ImgCover,
  WrapCover,
  BackgroundArrow,
  WrapSlider,
  WrapCard,
  CardTopHead,
  DefaultCover,
}
